import { Base } from './base';

export class Marker extends Base{
    MarkerID: number;
    ParkingTypeID: number;
    Latitude: number;
    Longitude: number;
    Icon: string;

    constructor(markerId: number, parkingTypeId: number, latitude: number, longitude: number, icon: string){
        super();
        this.MarkerID = markerId;
        this.ParkingTypeID = parkingTypeId;
        this.Latitude = latitude;
        this.Longitude = longitude;
        this.Icon = icon;
    }
}